"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalDomains = exports.isDeviantArtDomain = void 0;
exports.isDeviantArtDomain = function (params) {
    return !!(params === null || params === void 0 ? void 0 : params.deviantArtUserId);
};
var ExternalDomains;
(function (ExternalDomains) {
    ExternalDomains["DEVIANT_ART"] = "deviantart";
})(ExternalDomains = exports.ExternalDomains || (exports.ExternalDomains = {}));
//# sourceMappingURL=externalDomains.js.map